import {FinancingRateMatrixCell, SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {ensureActiveFinancingCell} from './ensureActiveFinancingCell';

export function removeFinancingCell(
  body: SaveSaleVehicleFinancingBody,
  cellToRemove: FinancingRateMatrixCell
) {
  const isActiveCell =
    body.activeTerm === cellToRemove.term &&
    body.activeDownPayment === cellToRemove.downPayment &&
    body.activeBalloonPayment === cellToRemove.balloonPayment;

  return ensureActiveFinancingCell({
    ...body,
    activeTerm: isActiveCell ? null : body.activeTerm,
    activeDownPayment: isActiveCell ? null : body.activeDownPayment,
    activeBalloonPayment: isActiveCell ? null : body.activeBalloonPayment,
    rateMatrix: {
      ...body.rateMatrix,
      cells: body.rateMatrix.cells.filter(
        (cell) =>
          !(
            cell.term === cellToRemove.term &&
            cell.downPayment === cellToRemove.downPayment &&
            cell.balloonPayment === cellToRemove.balloonPayment
          )
      ),
    },
  });
}
